<template>
    <v-container grid-list-md fluid>
        <v-card class='credit-card-inputs white-card' :class='{ complete }'>
        <h1 class="content-title">Subscriptions</h1>

            <h2>Please give us your payment details:</h2>

            <v-layout row wrap>
                
                <v-select
                    :items="subscriptionPlans"
                    v-model="subscriptionPlan"
                    label="Subscription plan"
                    single-line
                ></v-select>

                <v-flex xs12 sm12 md12 lg12>
                    <label class="float-left">Card Number : </label>
                    <card-number class='stripe-element card-number'
                    ref='cardNumber'
                    :stripe='stripeKey'
                    :options='options'
                    @change='number = $event.complete'
                    />
                </v-flex>

                <v-flex xs12 sm12 md12 lg12>
                    <label class="float-left">Expiry : </label>
                    <card-expiry class='stripe-element card-expiry'
                    ref='cardExpiry'
                    :stripe='stripeKey'
                    :options='options'
                    @change='expiry = $event.complete'
                />
                </v-flex>

                <v-flex xs12 sm12 md12 lg12>
                    <label class="float-left">CVC : </label>
                    <card-cvc class='stripe-element card-cvc'
                    ref='cardCvc'
                    :stripe='stripeKey'
                    :options='options'
                    @change='cvc = $event.complete'
                    />
                </v-flex>
                <v-btn class='pay-with-stripe' depressed block large color="success" @click='pay' :disabled='!complete || isSubscribing'>Pay</v-btn>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
    import axios from "axios";
    import { Card, CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus';
    import CONSTANT from '@/services/Constant.js';
    import stripeMixin from '@/services/stripeMixin.js';
    import UserService from "@/services/db/UserService.js";

    export default {
        name: "Subscriptions",
        props: ['stripe', 'options'],
        components: { Card, CardNumber, CardExpiry, CardCvc },
        data() {
            return {
                // fields
                complete: false,
                isSubscribing: false,
                subscriptionPlan: 'monthly',
                subscriptionPlans: CONSTANT.LIST.SUBSCRIPTION_PLANS_NEW,
                number: false,
                expiry: false,
                cvc: false,
                stripeOptions: {
                },
                stripeKey: CONSTANT.STRIPE_PK_KEY,
                name: "Connor Leech",
                email: "connor@employbl.com",
                specialNote: "This is test message",
                card: {
                    number: "4242424242424242",
                    cvc: "",
                    exp_month: "01",
                    exp_year: "19"
                },
                cardRules: {
                    number: [v => !!v || "Card Number is required"],
                    cvc: [v => !!v || "CVC is required"]
                },
                // validation
                cardNumberError: null,
                cardCvcError: null,
                cardMonthError: null,
                cardYearError: null,
                cardCheckSending: false,
                cardCheckError: false,
                cardCheckErrorMessage: "",
                currentUser: {}
            };
        },
        computed: {},
        watch: {
            number () { this.update() },
            expiry () { this.update() },
            cvc () { this.update() }
        },
        created ()  {
            var _USER = JSON.parse(this.$store.getters.loginUser);

            UserService.getUserById(_USER.userId).then(user => {
                this.currentUser = user;
            });
        },
        methods: {
            update () {
                this.complete = this.number && this.expiry && this.cvc

                // field completed, find field to focus next
                if (this.number) {
                    if (!this.expiry) {
                        this.$refs.cardExpiry.focus()
                    } else if (!this.cvc) {
                        this.$refs.cardCvc.focus()
                    }
                } else if (this.expiry) {
                    if (!this.cvc) {
                        this.$refs.cardCvc.focus()
                    } else if (!this.number) {
                        this.$refs.cardNumber.focus()
                    }
                }
                // no focus magic for the CVC field as it gets complete with three
                // numbers, but can also have four
            },
            pay () {
                // createToken returns a Promise which resolves in a result object with
                // either a token or an error key.
                
                this.isSubscribing = true;
                createToken().then(data => {
                    stripeMixin.stripeResponseHandler(data.token, (isSuccess, res) => {
                        
                        if (!isSuccess) {
                            this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.SUBSCRIPTION.SUB_FAIL});
                        } else {
                            var userModel = Object.assign({}, this.currentUser);
                            userModel['subscription_web'] = 'pro';

                            UserService.addNewUser(userModel, userModel.userId)
                            .then(() => {
                                this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.SUBSCRIPTION.SUB_SUCCESS});
                            })
                            .catch(() => {
                                this.$store.commit("setAlert", {
                                    isAlertError: true,
                                    message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED_FAIL
                                });
                            });
                        }
                        this.isSubscribing = false;
                    });
                })
            },

            validate() {
                let valid = true;
                if (!this.card.number) {
                    valid = false;
                    this.cardNumberError = "Card Number is Required";
                }
                if (!this.card.cvc) {
                    valid = false;
                    this.cardCvcError = "CVC is Required";
                }
                if (valid) {
                    this.createToken();
                }
            },

            createToken() {
                window.Stripe.setPublishableKey(this.stripeKey);
                window.Stripe.createToken(this.card, () => {                    
                    // this.stripeResponseHandler(status, response);
                });
                // window.Stripe.createToken(this.card, $.proxy(this.stripeResponseHandler, this));
            },

            stripeResponseHandler(token_from_stripe) {
                if (token_from_stripe) {
                    // token to create a charge on our server
                    // var token_from_stripe = response.id;

                    var request = {
                        token: token_from_stripe
                    };

                    // Send to our server
                    axios
                    .post(
                        CONSTANT.PAY_STRIPE_URL,
                        request
                    )
                    .then(res => {
                        var error = res.data.error;
                        // var charge = res.data.charge;
                        if (error) {
                            this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.SUBSCRIPTION.SUB_FAIL});
                        } else {
                            this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.SUBSCRIPTION.SUB_SUCCESS});
                        }
                    });
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .stripe-card {
        width: 300px;
        border: 1px solid grey;
    }
    .stripe-card.complete {
        border-color: green;
    }
    .credit-card-inputs.complete {
        border: 2px solid green;
    }
    .card-number, .card-expiry, .card-cvc, {
        padding: 5px;
    }
    button{
        font-size: 14px;
        font-weight: 500;
        background-color: #4caf50 !important;
        border-color: #4caf50 !important;
        border-radius: 2px;
        color: #fff;
        width: 100%;
        opacity: 0.89;
        padding: 10px;
        text-transform: uppercase;
    }
    button:disabled{
        background-color: rgba(0,0,0,.12)!important;
    }
    
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .mmp-title {
        text-align: center;
        font-size: 48px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .greeting {
        margin: auto;
    }
    .content-title {
        text-align: center;
        font-size: 32px;
        font-weight: bold;
    }
    .content-subTitle {
        padding-left: 10px;
        font-size: 24px;
        font-weight: bold;
    }
    .content-body {
        padding: 10px;
        font-size: 18px;
    }
</style>
